import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import STSComponent from "../STSComponent/STSComponent";
import "./css/InfoLine.scss";

class InfoLine extends STSComponent {
  returnTitle = (path) => {
    const { authData } = this.props;
    switch (path.replace(/^(.+?)\/*?$/, "$1")) {
      case "/legistrack":
      case "/regstrack":
      case "/localtrack":
      case "/billfinder":
        return "Legislative & Regulatory Tracking";
      case "/clientmanagement":
        return "Client Management";
      case "/localreview":
        return "Local Review";
      case "/localtrackinternal":
        return "Local Track";
      case "/registerreview":
        return "Register Review";
      case "/regsnewrecordreview":
        return "New Record Review - Regs";
      case "/legisnewrecordreview":
        return "New Record Review - Legis";
      case "/legistrackinternal":
        return "Legis Track";
      case "/statusreview":
        return "Status Review - Legis";
      case "/regstrackinternal":
        return "Regs Track";
      case "/currentlegislation":
        return "Current Legislation";
      case "/calendar":
        return "Calendar";
      case "/sponsorreview":
        return "Sponsor Review";
      case "/groupings":
        return "Groupings";
      case "/highlighter":
        return "Highlighter";
      case "/aitool":
        return "StateScape AI";
      case "/legsessions":
        return "Legislative Sessions";
      case "/regsurls":
        return "Agency Review";
      case "/rawbilldata":
        return "Raw Bill Data Entry";
      case "/clientlocalities":
        return "Client Localities";
      case "/agencyedit":
        return "Agency Edit";
      case "/historyhelptext":
        return "History Action Help Text";
      case "/meetingdates":
        return "Public Policy Meetings";
      case "/legislatordata":
        return "Legislator Management";
      case "/regsinjector":
        return "Add Regulation";
      case "/":
        return authData.Permissions.includes("Intranet")
          ? ""
          : `${authData.ClientName} User Dashboard`;
    }
  };

  render() {
    const infoLineSubtitle = sessionStorage.getItem("infoLineSubtitle");
    window.sessionStorage.removeItem("infoLineSubtitle");

    const path =
      this.returnTitle(this.props.infoLineTitle) +
      (infoLineSubtitle ? " - " + infoLineSubtitle : "");
    return (
      <div className="info-line-wrap container-fluid">
        <div className="info-line-bg-left" />
        <div className="info-line-bg-right" />
        <div className="info-line-container row">
          <div className="info-line-left-tweak">
            <div className="info-line-tweak-middle-block" />
            <div className="info-line-tweak-last-block" />
          </div>
          <h2 className="info-line-text">{path}</h2>
        </div>
      </div>
    );
  }

  static propTypes = {
    authData: PropTypes.object,
    infoLineTitle: PropTypes.string,
  };
}

export default connect(
  (state) => ({
    authData: state.auth.authData,
    infoLineTitle: state.router.location.pathname,
  }),
  {}
)(InfoLine);



// WEBPACK FOOTER //
// ./src/components/InfoLine/InfoLine.js